module.exports = __webpack_public_path__ + "static/media/mazaZoleWon_75_100.7f792bf4.png";